const rankings = [
  { rank: 1, title: '暗香', author: '墨染青衣', genre: '古风权谋', heat: '980万', trend: 'up' },
  { rank: 2, title: '夜行', author: '寒川', genre: '悬疑探案', heat: '876万', trend: 'up' },
  { rank: 3, title: '青涩', author: '林深时见', genre: '校园青春', heat: '765万', trend: 'up' },
  { rank: 4, title: '星河', author: '远舟', genre: '科幻星际', heat: '698万', trend: 'down' },
  { rank: 5, title: '逆光', author: '温酒', genre: '都市情感', heat: '612万', trend: 'up' },
  { rank: 6, title: '浮生', author: '云中鹤', genre: '仙侠玄幻', heat: '589万', trend: 'down' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100 scroll-mt-[64px]">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            人气排行
          </h2>
          <p className="text-sm text-foreground-500">最受读者欢迎的免费 BL 漫画作品</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {rankings.map((item) => (
            <a
              key={item.rank}
              href="#ranking"
              className="group flex items-center gap-4 p-4 bg-background-50 rounded-lg hover:bg-primary-50/50 transition-colors"
            >
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center">
                {item.rank <= 3 ? (
                  <span className="w-7 h-7 rounded-full bg-primary-500 flex items-center justify-center text-background-50 text-xs font-bold">
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-lg font-bold text-foreground-400">{item.rank}</span>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900">
                    《{item.title}》
                  </h3>
                  <span className="text-[11px] px-1.5 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {item.genre}
                  </span>
                </div>
                <p className="text-xs text-foreground-500">{item.author}</p>
              </div>
              <div className="flex flex-col items-end gap-0.5 flex-shrink-0">
                <span className="text-xs font-semibold text-primary-600 whitespace-nowrap">{item.heat}</span>
                <i
                  className={`text-xs ${
                    item.trend === 'up' ? 'ri-arrow-up-line text-primary-500' : 'ri-arrow-down-line text-foreground-400'
                  }`}
                ></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}